import { Phrases } from '@shared/models/locales.model';

export default {
  AssignedTo: 'Assigned to',
  AcceptedBy: 'Accepted by',
  Driver: 'Driver',
  Truck: 'Truck',
  Location: 'Location',
  GateDefinition: {
    inBound: 'In-bound',
    outBound: 'Out-bound',
    both: 'Both',
    temperatureControl: 'Temperature Control',
    temperatureControlText: 'If not selected it means that the gate temperature is normal.',
    gateName: 'Gate Name',
    referenceID: 'Reference ID',
    truckClassify: 'Truck Classify',
    Frozen: 'Frozen',
    Chiller: 'Chiller',
    GatesManagement: 'Gates Management',
    addGateDesc: 'Click "Add Gate" to configure location gates',
    addGate: 'Add Gate',
    addAnotherGate: 'Add Another Gate',
    gates: 'Gates',
    DeviceDistance: 'Device distance',
  },
  ShippingCard: {
    Pickup: 'Pickup',
    Dropoff: 'Dropoff',
    Clients: 'Clients',
    Orders: 'Orders',
    ContactPerson: 'Contact person',
    NoContact: 'No contact',
    Phone: 'Phone',
    NotMentioned: 'Not mentioned',
    PickupTime: 'Pickup time',
    DropoffTime: 'Dropoff time',
    CompletedOn: 'Completed on',
    NotDeliveredYet: 'Not delivered yet',
    NotCompletedYet: 'Not completed yet',
    OTP: 'OTP',
  },
  PlateNumber: {
    External: 'External',
  },

  'UndetailedOrders.AllOrdersWithCount': 'All {{count}} Orders',
  'UndetailedOrders.PalletsWithCount': 'Pallets {{count}}',
  'UndetailedOrders.ItemsWithCount': 'Items {{count}}',
  'UndetailedOrders.Pallets': 'Pallets',
  'UndetailedOrders.CreatedAt': 'Created At',
  'UndetailedOrders.OrderType.StockToCustomerStock': 'Stock Transfer',
  'UndetailedOrders.OrderType.StoTransfer': 'Stock Transfer',
  'UndetailedOrders.OrderType.Z122': 'Stock Transfer',
  'UndetailedOrders.OrderType.CustomerOutboundOrders': 'Outbound Transfer',
  'UndetailedOrders.OrderType.CustomerReturn': 'Customer Return',
  'UndetailedOrders.OrderType.CustomerReturnNupcoStock': 'Customer Return Nupco Stock',
  'UndetailedOrders.OrderType.NupcoSalesReturns': 'Nupco Sales Returns',
  'UndetailedOrders.OrderType.DistributionOutboundOrder': 'Distribution Outbound Order',
  'UndetailedOrders.OrderType.TransferOrders': 'Transfer Orders',
  'UndetailedOrders.OrderType.VendorSupplierReturns': 'Vendor Supplier Returns',
  'UndetailedOrders.OrderType.SalesOrder': 'Sales Order',
  'UndetailedOrders.OrderType.NupcoRoyalCourt': 'Nupco Royal Court',
  'UndetailedOrders.OrderType.NupcoDonationIssue': 'Nupco Donation Issue',
  'UndetailedOrders.OrderType.ScrapOrders': 'Scrap Orders',
  'UndetailedOrders.OrderType.PrepareOrder': 'Prepare Order',
  'UndetailedOrders.OrderType.SalesWithPrice': 'Sales With Price',

  'ShipmentAssignment.OverrideDetected': 'Override detected',
  'ShipmentAssignment.Kindly': 'kindly know that ',
  'ShipmentAssignment.TheDriver': 'the driver ',
  'ShipmentAssignment.TheTruck': 'the truck ',
  'ShipmentAssignment.HasRunningShipment': 'has a running shipment ',
  'ShipmentAssignment.From': ' From ',
  'ShipmentAssignment.To': 'To',
  'ShipmentAssignment.CloseShipment': 'would you like to hard close ',
  'ShipmentAssignment.ThisShipment': 'This shipment',
  'ShipmentAssignment.ThoseShipments': 'Those shipments',
  'ShipmentAssignment.WillStart': ' will start once',
  'ShipmentAssignment.Shipment': 'shipment',
  'ShipmentAssignment.Is': 'is',
  'ShipmentAssignment.Are': 'are',
  'ShipmentAssignment.SuccessfullyDelivered': ' successfully delivered',
  'ShipmentAssignment.ScheduleConflict': 'Schedule Conflict',
  'ShipmentAssignment.ConfirmOverride': 'Confirm Override',
  'ShipmentAssignment.ConfirmOverrideHint': 'Hard close the running shipment, then assign this one.',
  'ShipmentAssignment.JustAssign': 'Just Assign',
  'ShipmentAssignment.JustAssignHint': 'Assign this shipment and leave the running one as it is.',
  'ShipmentAssignment.AssignAndAutoStart': 'Assign and Auto-start',
  'ShipmentAssignment.AssignAndAutoStartHint': 'Assign now and start this shipment automatically once the running one is delivered.',
  'ShipmentAssignment.Justification': 'Justification',
  'ShipmentAssignment.ErrorMessageRequired': ' Required',
  'ShipmentAssignment.Hint': 'Hint',
  'Orders.AllOrdersWithCount': 'All {{count}} Orders',
  'Orders.PalletsWithCount': 'Pallets {{count}}',
  'Orders.ItemsWithCount': 'Items {{count}}',
  'Orders.CreatedAt': 'Created At',
  'Orders.Pallets': 'Pallets',
  'Orders.Items': 'Items',
  'OrderType.StockToCustomerStock': 'Stock Transfer',
  'OrderType.StoTransfer': 'Stock Transfer',
  'OrderType.Z122': 'Stock Transfer',
  'OrderType.MOIR': 'MOI-R',
  'OrderType.ZPG1': 'ZPG1',
  'OrderType.CustomerOutboundOrders': 'Outbound Transfer',
  'OrderType.CustomerReturn': 'Customer Return',
  'OrderType.CustomerReturnNupcoStock': 'Customer Return Nupco Stock',
  'OrderType.NupcoSalesReturns': 'Nupco Sales Returns',
  'OrderType.DistributionOutboundOrder': 'Distribution Outbound Order',
  'OrderType.TransferOrders': 'Transfer Orders',
  'OrderType.VendorSupplierReturns': 'Vendor Supplier Returns',
  'OrderType.SalesOrder': 'Sales Order',
  'OrderType.NupcoRoyalCourt': 'Nupco Royal Court',
  'OrderType.NupcoDonationIssue': 'Nupco Donation Issue',
  'OrderType.ScrapOrders': 'Scrap Orders',
  'OrderType.PrepareOrder': 'Prepare Order',
  'OrderType.SalesWithPrice': 'Sales With Price',
  FailedToLogout: 'Failed To Logout',
  LoggedOutSuccessfully: 'Logged Out Successfully',
  FleetSurveyTitle: 'Great job, you’ve completed new 20 shipments! 🎉',
  ThankYouMessage: 'Thank you for using logistic Marketplace',
  RatingMessage: 'Please take a moment to rate your experience, your input helps us serve you better.',
  Excellent: 'Excellent',
  Good: 'Good',
  Bad: 'Bad',
  Submit: 'Submit',
  Notes: 'Notes',
  CompleteInfoText: 'Complete your Informations for trusted shipments with certified partners, official invoicing, and real-time tracking',
  CompleteInfo: 'Complete Information',
  CompleteInfoTitle: 'Complete my Info',
  CompleteInformationText: 'Complete your Informations for trusted shipments with certified partners, official invoicing, and real-time tracking',
  CRNumber: 'CR Number',
  VATNumber: 'VAT Number',
  CompanyName: 'Company Name',
  CompanyNamePlaceholder: 'Enter your company name',
  CRNumberPlaceholder: 'Enter your CR number',
  VATNumberPlaceholder: 'Enter your VAT number',
  RenewPasswordReminder: 'Renew Password Reminder',
  NoticeTitle: 'Notice: Your Password Will Expire Soon',
  NoticeBody:
    'Your password will expire in {{days}} days. You can renew at any time from your account settings.',
  ReminderTitle: 'Reminder: Your Password is Expiring Soon',
  ReminderBody:
    'Your password will expire in {{days}} days. We recommend renewing early to avoid interruptions.',
  UrgentTitle: 'Urgent: Your Password Expires Soon!',
  UrgentBodyDays:
    'Only {{days}} day(s) left before your password expires. Renew immediately to avoid interruption.',
  UrgentBodyExpired: 'Your password has expired. Renew now to restore access to all services.',
  DaysRemainingLabel: '{{days}} day(s) remaining',
  PasswordExpiredLabel: 'Password expired',
  Expired: 'Expired',
  DaysLeft: 'days left',
  RemindMeLater: 'Remind Me Later',
  RenewNow: 'Renew Password Now',
  MarkedAutoDelivered: 'Marked as Auto Delivered',
  BySystem: 'By System',
} as Phrases;
